import {FetchService} from "../../node_modules/cronus-theme/default/global/ts/fetch.service";

export function initKeycloakAuth() {
    handleOAuthCallback();

    document.querySelector('.js-keycloakLogin')?.addEventListener('click', handleLogin);
    document.querySelector('.js-keycloakLogout')?.addEventListener('click', handleLogout);
}

async function handleLogin(e) {
    e.preventDefault();
    const response = await FetchService.get(`/em/keyCloak/authenticate`);
    //const data = await response.json();
    if (response.success && response.loginUrl) {
        window.location.href = response.loginUrl;
    }
}

async function handleLogout(e) {
    e.preventDefault();
    const response = await FetchService.get('/em/keyCloak/logout');
    //const data = await response.json();
    if (response.success && response.logoutUrl) {
        window.location.href = response.logoutUrl;
    }
}

async function handleOAuthCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (!code) return;

    const response = await FetchService.get('/em/keyCloak/authenticate?code=' + encodeURIComponent(code));
    //const data = await response.json();

    if (response.isLoggedIn) {
        // Clean redirect: nur Basis-Pfad ohne Query-Parameter
        window.location.href = window.location.origin + window.location.pathname;
    }
}
